import custom from './custom'

custom.init()